import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function holdReactNavigatorPath(path: string) {
  window.pendingReactNavigatorPath = path;
}

function isCurrentPath(path: string) {
  return `${window.location.pathname}${window.location.search}` === path;
}

export function ReactNavigatorBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    const navigateTo = (path: string) => {
      if (isCurrentPath(path)) return;
      navigate(path);
    };
    window.reactNavigator = navigateTo;

    const pending = window.pendingReactNavigatorPath;
    if (pending) {
      window.pendingReactNavigatorPath = undefined;
      navigateTo(pending);
    }

    return () => {
      if (window.reactNavigator === navigateTo) window.reactNavigator = holdReactNavigatorPath;
    };
  }, [navigate]);

  return null;
}
